



































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Calendar from "../general/Calendar.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import CalendarUtils from "../../shared/CalendarUtils";
import CalendarEventJson from "../../shared/CalendarEventJson";

import RentalBookingJson, { defaultRentalBookingJson } from "../../shared/RentalBookingJson";
import { RentalItemInfoJson } from "../../shared/RentalItemJson";

import RentalItemJson from "../../shared/RentalItemJson";
import RentalConditionJson from "../../shared/RentalConditionJson";

export default Vue.extend({
  name: "RentalBookingAvailableCalendar",
  components: {
    Calendar,
    PointerMenu,
    Loading,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      CalendarUtils: CalendarUtils,
      rentalItemInfo: null as RentalItemInfoJson | null,
      availableAmounts: null as { [index: string]: { open: boolean; amount: number } } | null,
      availableEvents: null as CalendarEventJson[] | null,
      dateToShow: null as Date | null,
      currentBeginCalenderYearMonth: null as [number, number] | null,
      showBeginCalendar: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initAvailableCalendar();
  },
  mounted() {},
  methods: {
    initAvailableCalendar() {
      this.loadItemAvailableAmounts();
    },

    async loadItemAvailableAmounts() {
      if (this.currentBeginCalenderYearMonth != null) {
        var today = new Date();

        if (
          this.currentBeginCalenderYearMonth[0] == today.getFullYear() &&
          this.currentBeginCalenderYearMonth[1] == today.getMonth()
        ) {
          var from = today;
        } else {
          var from = new Date(this.currentBeginCalenderYearMonth[0], this.currentBeginCalenderYearMonth[1], 1);
        }

        var to = new Date(this.currentBeginCalenderYearMonth[0], this.currentBeginCalenderYearMonth[1] + 1, 0);

        if (from.getTime() >= today.getTime()) {
          await this.loadRentalItemAvailableDayAmounts(from, to);

          this.availableEvents = this.getAvailabilityEvents(this.getCalendarData());
        }
      }
    },

    async loadRentalItemAvailableDayAmounts(from: Date, to: Date) {
      if (this.data != null) {
        this.availableAmounts = null;

        let rc = RestClient;
        try {
          this.availableAmounts = await rc.getRentalItemAvailableDayAmounts(
            this.data.ID,
            from,
            to,
            true //TODO
          );
        } catch (e) {
          alert(e.message);
        }
      }
    },

    getCalendarData() {
      var data = [];

      if (this.data != null && this.availableAmounts != null) {
        let item: any;
        for (item in this.availableAmounts) {
          let dataItem = {
            date: "",
            availability: "",
            selectable: false,
            amount: 0,
          };

          dataItem.date = item;
          dataItem.availability = this.getAvailabilityStatus(this.data.amount, this.availableAmounts[item].amount);
          dataItem.selectable = this.availableAmounts[item].open;
          dataItem.amount = this.availableAmounts[item].amount;

          data.push(dataItem);
        }
      }

      return data;
    },

    getAvailabilityEvents(data: any[]) {
      var events: CalendarEventJson[] = [];

      for (let item of data) {
        let event: CalendarEventJson = {
          title: "",
          beginDateTime: "",
          endDateTime: "",
          state: "",
          eventData: {},
        };

        event.title = "";
        event.beginDateTime = item.date + "T" + "09:00:00";
        event.endDateTime = item.date + "T" + "17:00:00";
        event.state = item.availability;

        event.eventData = {
          selectable: item.selectable,
          amount: item.amount,
        };

        events.push(event);
      }

      return events;
    },

    getAvailabilityStatus(maxAmount: number, availableAmount: number) {
      if (availableAmount <= 0) {
        return "booked";
      } else if (maxAmount == availableAmount) {
        return "available";
      } else {
        return "overbooked";
      }
    },

    //START set cached data

    //END set cached data

    /* Calendar START */

    calenderBeginCurrentYearMonth(year: number, month: number) {
      this.availableEvents = null;

      this.currentBeginCalenderYearMonth = [year, month];
      this.loadItemAvailableAmounts();
    },

    jumpToDateInCal(date: Date) {
      this.dateToShow = date;
    },

    /* Calendar END */

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    emitDateClicked(isoDate: string) {
      this.$emit("dateClicked", isoDate);
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {},

  computed: {},
});
